import { Common, ApiBind } from './common.model';

export class PlacementAssetInformation extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'asset_type' })
  assetType: number;

  @ApiBind({ column: 'message' })
  message: string;
}
